import { getApiRoot } from '~/utilities/api';

export const downloadOffer = async (offer: any, nft: any) => {
  useTrackEvent('offer_download');
  const offerBech32 = await $fetch<any>(`${getApiRoot()}/offers/${offer.id}/bech32`);

  if (offerBech32) {
    const c = document.createElement('a');
    c.download = `1_${nft.encoded_id}_x_${offer.xch_price}XCH.offer`;

    const t = new Blob([offerBech32], {
      type: 'text/plain',
    });
    c.href = window.URL.createObjectURL(t);
    c.click();
  }
};
